import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  getCertificatesRequest: ['params'],
  getCertificatesSuccess: ['certificates', 'total', 'pages', 'currentPage'],
  getCertificatesFailure: ['error']
})

const INITIAL_STATE = {
  certificates: [],
  total: 0,
  pages: 1,
  currentPage: 1,
  isLoading: false,
  error: false
}

// Get form data
export const getCertificatesRequest = (state = INITIAL_STATE) => ({ ...state, isLoading: true })
export const getCertificatesSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: false,
    certificates: action.certificates || [],
    total: action.total || 0,
    pages: action.pages || 1,
    currentPage: action.currentPage || 1
  }
}
export const getCertificatesFailure = (state = INITIAL_STATE, action) => ({ ...state, isLoading: false, error: action.error })
export default createReducer(INITIAL_STATE, {
  [Types.GET_CERTIFICATES_REQUEST]: getCertificatesRequest,
  [Types.GET_CERTIFICATES_SUCCESS]: getCertificatesSuccess,
  [Types.GET_CERTIFICATES_FAILURE]: getCertificatesFailure
})
